import { render } from "./LoginForm.vue?vue&type=template&id=a22ca370&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=a22ca370&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a22ca370"]])

export default __exports__